<p-table
    #pUserTable
    [columns]="columns"
    [value]="users"
    [lazy]="true"
    (onLazyLoad)="getUsers($event)"
    [paginator]="true"
    [rows]="tableRows"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [totalRecords]="userCount"
    [loading]="loading"
    [globalFilterFields]="['id', 'firstName', 'lastName', 'email', 'userName']"
    [responsive]="true"
    styleClass="p-datatable-striped"
>
    <ng-template pTemplate="caption">
        <div class="row mb-1">
            <div class="col-md-3">
                <input
                    type="text"
                    class="form-control"
                    placeholder="Arama yapabilirsiniz..."
                    (input)="pUserTable.filterGlobal($event.target['value'], 'contains')"
                />
            </div>
            <div class="col-md-9 text-right">
                <button class="btn btn-info btn-sm-block mr-1" (click)="getAllUsers()">
                    <i class="fa fa-redo"></i>Listeyi Yenile
                </button>
                <ng-template [ngxPermissionsOnly]="['AddUser']">
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="addUserForm.patchValue({ id: 0 }); addUserDialog = true"
                    >
                        <i class="fa fa-plus-circle"></i>Yeni Kullanıcı
                    </button>
                </ng-template>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns" [ngStyle]="{ width: col.width ? col.width : 'auto' }">
                {{ col.header }}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
            <td *ngFor="let col of columns">
                <ng-container *ngIf="!col.custom; else customField">
                    {{ rowData[col.field] }}
                </ng-container>
                <ng-template #customField>
                    <ng-container *ngIf="col.field === 'actions'">
                        <div class="text-center">
                            <ng-template [ngxPermissionsOnly]="['UpdateUser']">
                                <button class="btn btn-dark btn-icon mr-1 btn-sm"
                                        pTooltip="Görüntüle"
                                        tooltipPosition="left"
                                        (click)="showDetailForUser(rowData)">
                                    <i class="fa fa-eye"></i>
                                </button>
                            </ng-template>
                            <ng-template [ngxPermissionsOnly]="['UpdateUser']">
                                <button class="btn btn-warning btn-icon mr-1 btn-sm"
                                        pTooltip="Düzenle"
                                        tooltipPosition="left"
                                        (click)="showDialogForUserEdit(rowData)">
                                    <i class="fa fa-edit"></i>
                                </button>
                            </ng-template>
                            <ng-template [ngxPermissionsOnly]="['RemoveUser']">
                                <button class="btn btn-danger btn-icon mr-1 btn-sm" pTooltip="Sil" tooltipPosition="left" (click)="deleteUser(rowData['id'])">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </ng-template>
                            <ng-template [ngxPermissionsOnly]="[
                                    'UpdateEducationInformationFromYoksis',
                                    'UpdateIdentificationInformationFromMernis'
                                ]">
                                <div ngbDropdown class="d-inline-block">
                                    <button class="btn btn-primary btn-sm" id="ddOperations" ngbDropdownToggle>
                                        <i class="fa fa-ellipsis-v"></i> İşlemler
                                    </button>
                                    <div ngbDropdownMenu aria-labelledby="ddOperations">
                                        <ng-template [ngxPermissionsOnly]="['UpdateEducationInformationFromYoksis']">
                                            <button ngbDropdownItem (click)="updateEducationInformationFromYoksis(rowData['id'])">
                                                <i class="fa fa-school fa-fw"></i> Eğitim Bilgilerini Yöksis'ten Güncelle
                                            </button>
                                        </ng-template>
                                        <ng-template [ngxPermissionsOnly]="['UpdateIdentificationInformationFromMernis']">
                                            <button ngbDropdownItem
                                                    (click)="updateIdentificationInformationFromMernis(rowData['id'])">
                                                <i class="fa fa-id-card fa-fw"></i> Kimlik Bilgilerini Mernis'ten Güncelle
                                            </button>
                                        </ng-template>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </ng-container>
                </ng-template>
            </td>
        </tr>
    </ng-template>
    <!-- <ng-template pTemplate="summary" let-rowData>
        <div class="text-right">
            <button type="button" class="btn btn-primary" pButton icon="pi pi-plus" (click)="ekleKullanici()">
                Yeni Kullanıcı
            </button>
        </div>
    </ng-template> -->
</p-table>
<p-dialog
    header="Yeni Kullanıcı Ekle"
    [(visible)]="addUserDialog"
    [focusOnShow]="false"
    showEffect="fade"
    [modal]="true"
    position="top"
    [appendTo]="'body'"
    styleClass="operation-dialog"
    (onHide)="addUserForm.reset()"
>
    <form class="row" autocomplete="off" [formGroup]="addUserForm" (ngSubmit)="addUser()">
        <div class="form-group col-md-6">
            <label for="email">Eposta</label>
            <input
                id="email"
                class="form-control"
                type="email"
                formControlName="email"
                autocomplete="new-email"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.email.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.email.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.email.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.email.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.email.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.email.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.email.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.email.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.email.errors['maxlength'].actualLength }}
            </div>
        </div>
        <div class="form-group col-md-6">
            <label for="email">Kimlik Numarası</label>
            <input
                class="form-control"
                type="text"
                formControlName="userName"
                autocomplete="new-email"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.userName.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.userName.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.userName.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.userName.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.userName.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.userName.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.userName.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.userName.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.userName.errors['maxlength'].actualLength }}
            </div>
        </div>
        <div class="form-group col-md-6">
            <label for="firstName">Adı</label>
            <input
                id="firstName"
                class="form-control"
                type="text"
                formControlName="firstName"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.firstName.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.firstName.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.firstName.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.firstName.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.firstName.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.firstName.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.firstName.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.firstName.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.firstName.errors['maxlength'].actualLength }}
            </div>
        </div>
        <div class="form-group col-md-6">
            <label for="lastName">Soyadı</label>
            <input
                id="lastName"
                class="form-control"
                type="text"
                formControlName="lastName"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.lastName.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.lastName.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.lastName.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.lastName.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.lastName.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.lastName.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.lastName.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.lastName.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.lastName.errors['maxlength'].actualLength }}
            </div>
        </div>
        <div class="form-group col-md-12" *ngIf="addUserForm.controls.id.value > 0">
            <div class="form-check">
                <input id="isPasswordUpdated" type="checkbox" class="form-check-input" formControlName="isPasswordUpdated" />
                <label class="form-check-label" for="isPasswordUpdated">Parola Güncellensin mi?</label>
            </div>
        </div>

        <div class="form-group col-md-6">
            <label for="password">Parola</label>
            <input
                id="password"
                class="form-control"
                type="password"
                formControlName="password"
                autocomplete="new-password"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.password.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.password.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.password.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.password.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.password.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.password.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.password.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.password.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.password.errors['maxlength'].actualLength }}
            </div>
        </div>
        <div class="form-group col-md-6">
            <label for="passwordRepeat">Parola Tekrar</label>
            <input
                id="passwordRepeat"
                class="form-control"
                type="password"
                formControlName="passwordRepeat"
                autocomplete="new-passwordRepeat"
                [ngClass]="{
                    'is-invalid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.passwordRepeat.invalid,
                    'is-valid': (addUserForm.dirty || addUserForm.touched) && addUserForm.controls.passwordRepeat.valid
                }"
            />
            <div class="invalid-feedback" *ngIf="addUserForm.controls.passwordRepeat.hasError('required')">
                {{ 'VALIDATION.REQUIRED_FIELD' | translate }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.passwordRepeat.hasError('minlength')">
                {{ 'VALIDATION.MIN_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.passwordRepeat.errors['minlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.passwordRepeat.errors['minlength'].actualLength }}
            </div>
            <div class="invalid-feedback" *ngIf="addUserForm.controls.passwordRepeat.hasError('maxlength')">
                {{ 'VALIDATION.MAX_LENGTH_FIELD' | translate }}
                {{ addUserForm.controls.passwordRepeat.errors['maxlength'].requiredLength }}
                {{ 'VALIDATION.ENTERED' | translate }}
                {{ addUserForm.controls.passwordRepeat.errors['maxlength'].actualLength }}
            </div>
        </div>

        <div class="form-group col-md-12">
            <div class="form-check form-check-inline" *ngFor="let role of roles">
                <input
                    id="roleCheck"
                    class="form-check-input"
                    type="checkbox"
                    [checked]="role.selected"
                    (change)="role.selected = $event.target['checked']"
                />
                <label class="form-check-label" for="roleCheck">{{ role.name }}</label>
            </div>
        </div>
        <div class="text-right col-md-12">
            <button class="btn btn-secondary mr-1" type="button" (click)="addUserDialog = false">
                <i class="fa fa-times"></i> Kapat
            </button>
            <button class="btn btn-success" [disabled]="addUserForm.invalid"><i class="fa fa-save"></i> Kaydet</button>
        </div>
    </form>
</p-dialog>
<p-confirmDialog #cd header="Onay" icon="pi pi-exclamation-triangle" appendTo="body">
    <p-footer>
        <button class="btn btn-secondary mr-1" type="button" (click)="cd.reject()">
            <i class="fa fa-times"></i> Hayır
        </button>
        <button type="submit" class="btn btn-info" (click)="cd.accept()">
            <i class="fa fa-check"></i> Evet
        </button>
    </p-footer>
</p-confirmDialog>
